import type { FC } from "react";

import type { RedirectionLinkCardProps } from "@ui/components/RedirectionLinkCard";
import { RedirectionLinkCard } from "@ui/components/RedirectionLinkCard";

import { useConfig } from "@jti/app-context/useConfig";
import type { Config } from "@jti/fe-common";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import styles from "./FooterList.module.scss";

export type FooterListProps = {
  items?: RedirectionLinkCardProps[];
};

const dispatchGTMEvent = (item: RedirectionLinkCardProps, config: Config) => {
  if (item.trackingEvent) {
    const trackingMap = {
      phone_click: TrackingEvents.TrackingContactUsPhoneClick,
      contact_click: TrackingEvents.TrackingContactUsClick,
      store_locator_click: TrackingEvents.TrackingStoreLocatorClick,
    } as const;

    const trackingEvent = trackingMap[item.trackingEvent];
    if (trackingEvent) {
      dispatchTrackingEvent(trackingEvent);
      return;
    }
  }

  if (item.link?.startsWith("tel:")) {
    dispatchTrackingEvent(TrackingEvents.TrackingContactUsPhoneClick);
    return;
  }

  if (item.link === config.CONTACT_US_URL) {
    dispatchTrackingEvent(TrackingEvents.TrackingContactUsClick);
    return;
  }

  dispatchTrackingEvent(TrackingEvents.TrackingMenuNavigationClick, {
    menu_link: item.title,
  });
};

export const FooterList: FC<FooterListProps> = ({ items = [] }) => {
  const config = useConfig();

  if (items.length === 0) {
    return null;
  }

  return (
    <ul className={styles.list}>
      {items.map((item, index) => {
        const { title, link, isArrowHidden } = item;

        return (
          <li key={link + title + index} className={styles.item}>
            <RedirectionLinkCard
              variant="list"
              title={title}
              link={link ?? ""}
              onClick={() => dispatchGTMEvent(item, config)}
              isArrowHidden={isArrowHidden}
            />
          </li>
        );
      })}
    </ul>
  );
};
